module.exports = __webpack_public_path__ + "img/partner_logo9.8543efea.png";